import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { HttpErrorHandler } from '../../shared/http-error-handler';

import { AuthenticationService } from '../../_services/authentication.service';
import { IncidenceService } from '../../_services/incidence.service';

import { Association } from 'app/_models/association';
import { ExpirationService } from 'app/_services/expiration.service';
import { ProfileService } from 'app/_services/profile.service';
import { Profile } from '../../_models/profile';

@Component({
  selector: 'app-menu',
  templateUrl: './app-menu.component.html',
  styleUrls: ['./app-menu.component.scss'],
})
export class AppMenuComponent implements OnInit {
  @ViewChild('container') container;
  @ViewChild('dropdown') dropdown;

  totalIncidences = 0;
  dropDownFlag = false;
  profile: Profile;
  associations: Association[] = [];
  currentAssociation: number;
  numberExpirations: string;

  // Mixins prototypes
  errorRouter: Router;

  constructor(
    private expirationService: ExpirationService,
    private authenticationService: AuthenticationService,
    private profileService: ProfileService,
    private incidenceService: IncidenceService,
    private router: Router,
    private httpErrorHandler: HttpErrorHandler
  ) {
    document.addEventListener('click', this.offClickHandler.bind(this));
  }

  offClickHandler(event: any) {
    if (!this.container.nativeElement.contains(event.target)) {
      this.dropDownFlag = false;
    }
  }

  ngOnInit() {
    this.profile = Profile.apiMap(JSON.parse(localStorage.getItem('profile')));

    this.authenticationService.getAccessData().forEach((item) => {
      if (item['id'] !== +this.authenticationService.getXAssociation()) {
        this.associations.push(Association.apiMap(item));
      }
    });

    this.getTotalIncidences();
  }

  logout(event) {
    event.preventDefault();
    this.authenticationService.logout();
    this.router.navigate(['/login']);
  }

  getTotalIncidences() {
    this.incidenceService.getTotal().subscribe(
      (data) => {
        this.totalIncidences = data['total_incidences'];
      },
      (error) => this.httpErrorHandler.handleHttpError(error)
    );
  }

  public switchAssociation(event, association) {
    event.preventDefault();
    this.authenticationService.setXAssociation(association.id);

    this.profileService.profile().subscribe((profile) => {
      this.profileService.saveProfile(profile);
      location.reload();
    });
  }

  public toggleDropdown(event) {
    event.preventDefault();
    this.dropDownFlag = !this.dropDownFlag;
  }
}



// WEBPACK FOOTER //
// ./src/app/common/app-menu/app-menu.component.ts